angular.module('galilai.creator').controller('SocialConnectController', function($scope, api, $rootScope, $timeout) {

    $scope.init = function() {
        console.log('SocialConnectController');
    }

    $scope.hideModal = function() {
        let socialConnectModal = angular.element('#socialconnect-modal')
        if (socialConnectModal) {
            socialConnectModal.modal('hide')
        }
    }
    $scope.preConnectOpen = function(kind) {
        api.socialPreConnect()
        .then(function() {
            window.open('/connect/' + kind, '_system')
            $rootScope.$emit('startMonitoringSocialPages')
            $scope.hideModal()
        })
        .catch(function(err) {
            showError(gettext('error.generic'))
        })
    }

    $scope.showInstructions = function() {
        $rootScope.$emit('showInstructions')
    }

    $scope.connect = function(kind) {
        if (kind == 'facebook') {
            $rootScope.$emit('doFacebookAuth')
            $scope.hideModal()
        }
        if (kind == 'linkedin') {
            $scope.preConnectOpen('linkedin')
        }
    }
})